import { render, staticRenderFns } from "./zylc.vue?vue&type=template&id=55fa1b1d&scoped=true"
import script from "./zylc.vue?vue&type=script&lang=js"
export * from "./zylc.vue?vue&type=script&lang=js"
import style0 from "./zylc.vue?vue&type=style&index=0&id=55fa1b1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fa1b1d",
  null
  
)

export default component.exports